import { render } from "./VZPhone.vue?vue&type=template&id=455489bd&scoped=true"
import script from "./VZPhone.vue?vue&type=script&lang=js"
export * from "./VZPhone.vue?vue&type=script&lang=js"

import "./VZPhone.vue?vue&type=style&index=0&id=455489bd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455489bd"]])

export default __exports__